// What the dashboard says about the last bank email. Import-free so the unit
// tests can load it.

export interface BankEmailNote {
  /** "warn" is for the cases where the org may need to do something by hand. */
  tone: "quiet" | "warn";
  text: string;
}

/** The outcome intake recorded for an email, in words for the org. Rows from
 *  before outcomes were recorded have none. */
export function bankEmailNote(outcome: string | null | undefined): BankEmailNote {
  switch (outcome) {
    case "confirmed":
      return { tone: "quiet", text: "it matched a payment and confirmed it." };
    case "reference-confirmed":
      return { tone: "quiet", text: "it was for a payment that was already confirmed." };
    case "reference-expired":
      return {
        tone: "warn",
        text: "it was for a request that had already expired, so nothing was confirmed. If it is yours, mark it paid.",
      };
    case "unverified":
      return {
        tone: "warn",
        text: "we couldn't check that it really came from your bank, so nothing was confirmed. If it is a real payment, mark it paid.",
      };
    case "not-incoming":
      return { tone: "quiet", text: "it wasn't a notice of money arriving, so it was ignored." };
    case "no-match":
      return { tone: "quiet", text: "it was read, but no waiting request matched it." };
    default:
      return { tone: "quiet", text: "it arrived." };
  }
}
